import { Injectable, inject } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PolicyIpAddressDto } from '../interfaces/policy-ip-address-dto';
import { PaginatedSearchFilter } from '../interfaces/paginated-search-filter';
import { PaginatedSearchResponse } from '../interfaces/paginated-search-response';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { PolicyType } from '../enums/policy-type';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class MfaPolicyIpAddressService {
    private readonly http = inject(HttpClient);
    private env = inject(envToken);


    policyMfaIpAddressesBaseUrl = '';

    constructor() {
        this.policyMfaIpAddressesBaseUrl = this.env.apiUrl + '/api/v1/policy-ip-addresses';
    }

    savePolicyMfaIpAddress(
        enterpriseId: number,
        ipAddressDto: PolicyIpAddressDto): Observable<PolicyIpAddressDto> {
         
        return this.http.post<PolicyIpAddressDto>(`${this.policyMfaIpAddressesBaseUrl}/enterprise/${enterpriseId}/${PolicyType.MFA}`, ipAddressDto);
    }

    deletePolicyMfaIpAddress(policyIpAddressDto: PolicyIpAddressDto): Observable<void> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.delete<void>(`${this.policyMfaIpAddressesBaseUrl}`, {
            headers,
            body: policyIpAddressDto
        });
    }

    fetchPolicyMfaIpAddresses(
        enterpriseId: number,
        filter: PaginatedSearchFilter): Observable<PaginatedSearchResponse<PolicyIpAddressDto>> {
        let params = new HttpParams()
            .set('page', filter.page)
            .set('size', filter.itemsPerPage)
            .set('sort', filter.sortBy + ',' + filter.sortOrder);
        if (filter.searchTerm) {
            params = params.set('searchTerm', filter.searchTerm);
        }
        return this.http.get<PaginatedSearchResponse<PolicyIpAddressDto>>(`${this.policyMfaIpAddressesBaseUrl}/enterprise/${enterpriseId}/${PolicyType.MFA}`, {
            params
        });
    }
}
